<div class="images-wrapper">
    @if (images() != null) {
        @for (image of images(); track $index; let i = $index) {
            <div
                ev_swipe
                (gesture)="onGesture($event, i)"
                class="image-container"
                [class.border-radius]="imageBorderRadius()"
                [class.showimg]="i === imageIndex()"
                (click)="openImage(image)"
            >
                @if (shouldLoadImage(i)) {
                    <img
                        #carouselImg
                        [attr.data-image-index]="i.toString()"
                        [authImage]="getImageUrl(image)"
                        [alt]="'Carousel image ' + (i + 1)"
                        class="carousel-image"
                    />
                } @else {
                    <img
                        #carouselImg
                        [attr.data-src]="getImageUrl(image)"
                        [attr.data-image-index]="i.toString()"
                        [src]="placeholderImage"
                        [alt]="'Carousel image ' + (i + 1)"
                        class="carousel-image"
                        loading="lazy"
                    />
                }
            </div>
        }
        <div class="no-images" [ngClass]="'property-' + estateType()"></div>
        <div [class.disabled]="imageIndex() <= 0" class="previous" (click)="changeindex(-1)"></div>
        <div [class.disabled]="imageIndex() >= images().length - 1" class="next" (click)="changeindex(1)"></div>
    }
</div>
<ng-template cdkPortal>
    <ev-image-viewer style="width: 100%" [imagePackages]="imagePackages()" (imageViewerClosed)="closeImageViewer()" [activeImage]="activeImage()">
    </ev-image-viewer>
</ng-template>
